package ai.beakman.undercover

/** `window.localStorage` do browser (sem dependência do kotlinx-browser). */
private external val localStorage: Storage

private external interface Storage {
    fun getItem(key: String): String?
    fun setItem(key: String, value: String)
}

// try/catch em tudo: Safari em modo privado (e storage desabilitado) lança exceção
// tanto no acesso quanto no setItem → fallback = identidade por sessão.

internal actual fun loadPersistedClientId(): String? =
    try {
        localStorage.getItem(IDENTITY_CLIENT_ID_KEY)
    } catch (_: Throwable) {
        null
    }

internal actual fun persistClientId(id: String) {
    try {
        localStorage.setItem(IDENTITY_CLIENT_ID_KEY, id)
    } catch (_: Throwable) {
        // no-op
    }
}

internal actual fun loadSavedName(): String? =
    try {
        localStorage.getItem(IDENTITY_PLAYER_NAME_KEY)
    } catch (_: Throwable) {
        null
    }

internal actual fun persistSavedName(name: String) {
    try {
        localStorage.setItem(IDENTITY_PLAYER_NAME_KEY, name)
    } catch (_: Throwable) {
        // no-op
    }
}

internal actual fun loadPersistedLanguage(): String? =
    try {
        localStorage.getItem(IDENTITY_LANGUAGE_KEY)
    } catch (_: Throwable) {
        null
    }

internal actual fun persistLanguageCode(code: String) {
    try {
        localStorage.setItem(IDENTITY_LANGUAGE_KEY, code)
    } catch (_: Throwable) {
        // no-op
    }
}
